import { gql } from 'graphql-tag'

export default gql`
  fragment GlobalDataRegionFragment on GlobalDataRegion {
    sys {
      id
    }
    name
    processingFeeAmount
    processingFeeCurrency {
      sys {
        id
      }
    }
  }
`
